/**
 * Represents a row within the table.
 */
export class TableRow {
  constructor(
    public data: any,
    public selected: boolean = false
  ) {}
}
